import { FC } from 'react'
import { useLayout } from './layout/core/LayoutProvider'

/**
 * Footer de la aplicacion: muestra marca Veolia, anio, version y creditos a Hábil.
 */
const Footer: FC = () => {
  const { classes } = useLayout()
  return (
    <div className='footer py-4 d-flex flex-lg-column' id='kt_footer'>
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}>
        <div className='order-2'>
          <p className='pull-right mb-0'>
            Hecho por
            <a
              href='https://www.habil.mx/'
              className='mx-1'
              style={{ color: 'rgb(44, 194, 226)' }}
              target='_blank'
              rel='noopener noreferrer'>
              Hábil
            </a>
            con
            <i className='fa fa-heart font-warning ms-1'></i>
          </p>
        </div>
        <div className='text-dark order-1 order-md-1'>
          <span className='text-gray-800 me-2'>{new Date().getFullYear()} &copy;</span>
          <span className='text-gray-800'>Veolia</span>
          <small className='text-muted ms-3'>{process.env.REACT_APP_VERSION}</small>
        </div>
      </div>
    </div>
  )
}

export { Footer }
